<template>
  <div class="home">
    <Header></Header>
    <Nav :title="title"></Nav>
    <div class="banner">
      <div class="left">
        <li
          v-for="(i, j) in navleft"
          :key="j"
          :class="nav_left == j ? 'isactive' : ''"
          @click="changeleft(j)"
        >
          {{ detailslist.title }}
        </li>
      </div>
      <div class="right">
        <div class="top">
          <p>
            当前位置：>><span
              @click="
                $router.push({
                  path: '/'
                })
              "
              >全部报纸</span
            >>>{{ detailslist.content }}
          </p>
        </div>
        <div class="content">
          <h1>{{ detailslist.title }}</h1>
          <p class="title">{{ detailslist.content }}</p>
          <div class="list">
            <viewer class="view" :images="detailslist.articleInfoList">
              <img
                v-for="(i, j) in detailslist.articleInfoList"
                :key="j"
                :src="'http://221.176.156.242:60080/' + i.imgPath"
                width="300"
              />
            </viewer>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Nav from "../components/nav.vue";
import API from "../api/api_user";
export default {
  name: "home",
  data() {
    return {
      title: "/information",
      nav_left: 0,
      navleft: [{ name: "18965256" }],
      detailslist: ""
    };
  },
  components: {
    Header,
    Footer,
    Nav
  },

  watch: {
    $route(to, from) {
      // 路由发生变化页面刷新
      this.$router.go(0);
    }
  },
  methods: {
    changeleft(j) {
      this.nav_left = j;
    },
    changetop(j) {
      this.nav_top = j;
    },
    getdetails() {
      API.details({
        articleId: this.$route.query.articleId
      }).then(res => {
        console.log(res.data);
        this.detailslist = res.data;
      });
    }
  },
  computed: {},
  created() {
    this.getdetails();
  },
  mounted() {}
};
</script>
<style>
/* 内容 */
.home .banner {
  width: 1200px;
  min-height: 400px;
  height: 800px;
  margin: 20px auto 0px;
  background-color: #fff;
  display: flex;
}
.home .banner .left {
  width: 20%;
  height: 800px;
  display: inline-block;
}
.home .banner .left li {
  list-style: none;
  vertical-align: top;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  border-bottom: 1px dashed #fff;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.home .banner .left .isactive {
  background-color: red;
}
.home .banner .right {
  width: 80%;
  height: 800px;
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  border: 1px solid #ccc;
}
.home .banner .right .top {
  width: 100%;
  height: 40px;
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
}
.home .banner .right .top p {
  margin: 0px;
  line-height: 40px;
  padding-left: 20px;
  font-size: 14px;
}
.home .banner .right .content {
  width: 100%;
  height: auto;
}
.home .banner .right .content h1 {
  text-align: center;
  margin: 15px auto;
  font-weight: 500;
  color: #666;
}
.home .banner .right .content .title {
  width: 95%;
  margin: 0 auto 20px;
  color: #666;
}
.home .banner .right .content .list {
  width: 95%;
  margin: 0 auto;
}
.home .banner .right .content .list .view {
  list-style: none;
  width: 100%;
  height: auto;
  display: inline-block;
}
.home .banner .right .content .list .view img {
  width: calc(20% - 20px);
  height: 200px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.home .banner .right .content .list .view p {
  margin: 0px;
  line-height: 30px;
  color: #999;
  font-size: 14px;
}
</style>
